// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__osP8o","theme":"navbar_theme__eZIIv","icon":"navbar_icon__UCxdH"};